// TODO: Move this JS file to Webpack folder since it is now only consumed by
// Webpacker-compiled applications
import 'angular';

angular.module('directives.visualizations.emptyResults', [])
  .directive('emptyResults', [
    function() {
      return {
        restrict: 'E',
        template:
          '<div class="empty-results">' +
            '<div class="empty-results-placeholder text-center">' +
              '<div class="text text-gray-li">' +
                '<i class="fal icon-exclamation-triangle bigger-size text-gray-lig block"></i>' +
                '{{ message }}' +
              '</div>' +
              '<i class="watermark fal icon-chart-pie text-gray-lighter"></i>' +
            '</div>' +
          '</div>',
        scope: {
          message: '=?'
        },
        link: function(scope) {
          if(!scope.message) {
            scope.message = 'Sorry, there are no results matching your search criteria. ' +
                            'Please try some alternative keywords and filters.';
          }
        }
      };
    }
  ]);
